// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";

import type { Database } from "~/types/supabase";

const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL ||
  "https://mdrvhekhimhcwydrpueo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  import.meta.env.VITE_SUPABASE_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1kcnZoZWtoaW1oY3d5ZHJwdWVvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM1MzcyOTksImV4cCI6MjA1OTExMzI5OX0.XYVbRbA5VhJKv8p5Fe64oXfzeaoY7fMVPDfJlNXqElY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY
);
